import { Container } from "semantic-ui-react";
import MenuBySlug from "components/Menu/MenuBySlug";
import React from "react";

export function SocketMenu() {
  return <div className="SocketMenu top-menu-mini">
    <Container>
      <MenuBySlug slug={"footer"}/>
    </Container>
  </div>
}


// WEBPACK FOOTER //
// ./src/theme/oehme/components/Footer/SocketMenu.js